
export const MARKETPLACE_VERIFICATION_INSTRUCTION = 'Verify you are sending in the correct marketplace.';
export const TEST_EMAIL_REVIEW_INSTRUCTION = 'Carefully review test email to avoid html rendering errors.'
  + ' There may be standard header and footer wrapping plain text blurb below based on marketplace.';

export const FOLLOW_NOOGLE_LINKS = 'Follow noogle links for debugging: ';
export const ADDITIONAL_INFO = 'More instructions ';
